import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '我们少年有力量';
const baseUrl = 'powerFyoung0227';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/pathold/welcome`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
      {
        path: 'pathold/welcome',
        name: `${baseUrl}-welcome`,
        component: () => import('./pages/Welcome.vue'),
        meta: {
          title: PAGE_TITLE,
          rank: 1,
            keepPosition: true,
        },
      },
      {
          path: 'pathold/home',
          name: `${baseUrl}-listPage`,
          component: () => import('./pages/ListPage.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 1,
             keepPosition: true,
          },
    }, 
        {
          path: 'pathold/homeact',
          name: `${baseUrl}-listPageact`,
          component: () => import('./pages/ListPageact.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 1,
             keepPosition: true,
          },
        },
        {
          path: 'news',
          name: `${baseUrl}-news`,
          component: () => import('./pages/News.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        {
          path: 'rules',
          name: `${baseUrl}-rules`,
          component: () => import('./pages/Rules.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        {
          path: 'rank',
          name: `${baseUrl}-rank`,
          component: () => import('./pages/Rank.vue'),
          meta: {
            title: PAGE_TITLE,
          },
    },
    {
          path: 'listPageSearch',
          name: `${baseUrl}-listPageSearch`,
          component: () => import('./pages/ListPageSearch.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 1,
             keepPosition: true,
          },
        },
        {
          path: 'pathold/detail',
          name: `${baseUrl}-detail`,
          component: () => import('./pages/Detail.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 2,
            keepPosition: true,
          },
        },
        {
          path: 'pathold/register',
          name: `${baseUrl}-register`,
          component: () => import('./pages/Register.vue'),
          meta: {
            title: PAGE_TITLE,
            rank: 3,
          },
        },
        {
          path: 'pathold/user',
          name: `${baseUrl}-user`,
          component: () => import('./pages/User.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
  ]
  
};

export default route;
